




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import AgencyUserStatus from '@/models/AgencyUsers/AgencyUserStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';


@Component({
  name: 'WorkerStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: AgencyUserStatus;

	@Prop({required: true})
	location: StatusDisplayLocation;
	
	get textColor() {
		let color = "grey--text";
		switch (this.status) {
			case AgencyUserStatus.Active: {
				color = "green--text";
				break;
			}
			case AgencyUserStatus.Deleted: {
				color = "red-text";
				break;
			}
			default: {
				color = "grey-text";
				break;
			}
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case AgencyUserStatus.Active:
				text = "ACTIVE";
				break;
			case AgencyUserStatus.Deleted:
				text = "DELETED";
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}
	
	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("overline");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
